import React from "react";
import styled from "styled-components";

import { trackEvent } from "@trailhead/analytics";
import { Link } from "@trailhead/asurion-ui";
import {
    AppStoreCTA,
    GooglePlayCTA,
} from "@trailhead/core-ui";

const CTALink = styled(Link)`
  display: flex;
  text-decoration: none;
`;

export const AppStoreDownloadBtn = (): JSX.Element => (
    <CTALink
        onClick={() => trackEvent("AppleCTALinkClick")}
        href="https://apps.apple.com/us/app/tech-coach/id1065341814"
        target="_blank"
        rel="noopener noreferrer"
    >
        <AppStoreCTA />
    </CTALink>
);

export const GooglePlayDownloadBtn = (): JSX.Element => (
    <CTALink
        onClick={() => trackEvent("AndroidCTALinkClick")}
        href="https://play.google.com/store/apps/details?id=com.asurion.solutohome.verizon&hl=en_US&gl=US"
        target="_blank"
        rel="noopener noreferrer"
    >
        <GooglePlayCTA />
    </CTALink>
);